import {
    InfrastructureFilterActionTypes,
    InfrastructureFilterOptions,
    SET_INFRASTRUCTURE_FILTER,
} from './types'

export const setInfrastructureFilter = (
    newFilter?: Partial<InfrastructureFilterOptions>,
): InfrastructureFilterActionTypes => {
    return {
        type: SET_INFRASTRUCTURE_FILTER,
        newFilter: newFilter,
    }
}
